import { render, staticRenderFns } from "./ZamkniecieWizyty.vue?vue&type=template&id=4e59f44d&scoped=true"
import script from "./ZamkniecieWizyty.vue?vue&type=script&lang=js"
export * from "./ZamkniecieWizyty.vue?vue&type=script&lang=js"
import style0 from "./ZamkniecieWizyty.vue?vue&type=style&index=0&id=4e59f44d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e59f44d",
  null
  
)

export default component.exports